import React from 'react';
import Title from '../../../../@casino/ui/title';
import { useRouter } from '../../../../@casino/useRouter';
import TableCasino from '../../referrals/components/table';
import { useDispatch, useSelector } from 'react-redux';
import { setGetDictionary } from '../store/thunk/setGetDictionary';

const DictionaryList = () => {
    const router = useRouter();
    const dispatch = useDispatch();


    React.useEffect(() => {
        dispatch(setGetDictionary({
            language: 'RU',
            page: 1,
            rowsPerPage: 10,
        }))
    }, [])

    const list = useSelector(state => state.dictionary.list);
    
    const columns = [
        { id: 'code', label: 'Код', minWidth: 150, maxWidth: 150, width: 150 },
        { id: 'language', label: 'Язык', minWidth: 50, maxWidth: 50, width: 50 },
        { id: 'text', label: 'Текст' }
    ];
    const rows = list.list.map((item) => {
        return {
            promocode: item.id,
            code: item.code,
            language: item.language,
            text: item.text?.length > 150 ? item.text.slice(0, 150) + '...' : item.text
        }
    })

    return (
        <div style={{padding: '0 20px'}}>
            <Title
                label="Справочник" 
                labelBtn="Добавить"
                button={() => {
                    router.history.push('/settings/dictionary/create')
                }}
            />
            
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                width: 'calc(100% - 40px)', 
            }}>
                <TableCasino
                    route="/settings/dictionary/edit/"
                    columns={columns}
                    rows={rows}
                    pagination
                    allPage={list.countPage}
                    perPage={10}
                    changePage={(v) => {
                        dispatch(setGetDictionary({
                            language: 'RU',
                            page: +v.page+1,
                            rowsPerPage: v.rowsPerPage,
                        }))
                    }}
                    changeRowsPerPage={(v) => {
                        dispatch(setGetDictionary({
                            language: 'RU',
                            page: +v.page+1,
                            rowsPerPage: v.rowsPerPage,
                        }))
                    }}
                />
            </div>
        </div>
    )
}

export default DictionaryList;